import React from 'react';
import { useButtonStyles } from './hooks/useButtonStyles.js';
import { Loader } from './Loader.js';

const hasHref = (props) => 'href' in props;
const ButtonContent = ({ label, loading, }) => (React.createElement(React.Fragment, null,
    React.createElement("span", { className: ['transition-opacity', loading ? 'opacity-0' : ''].join(' ') }, label),
    React.createElement(Loader, { visible: loading })));
const Button = ({ className = '', disabled, filled = true, label, loading, rounded = false, size, variant, ...props }) => {
    const styles = useButtonStyles({ disabled, filled, rounded, size, variant });
    const attributes = {
        'aria-disabled': disabled,
        className: [
            'relative select-none cursor-pointer whitespace-nowrap',
            styles,
            loading || disabled ? 'pointer-events-none' : '',
            className,
        ].join(' '),
        ...props,
    };
    if (hasHref(props)) {
        return (React.createElement("a", { ...attributes },
            React.createElement(ButtonContent, { ...{ label, loading } })));
    }
    return (React.createElement("button", { ...attributes },
        React.createElement(ButtonContent, { ...{ label, loading } })));
};

export { Button };
//# sourceMappingURL=Button.js.map
